import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, ChevronRight, Settings } from 'react-feather';
import { useMonth } from '../contexts/MonthContext';

interface PageHeaderProps {
  // 'month' renders the ‹ Juli › switcher, 'title' renders a static title
  mode: 'month' | 'title';
  title?: string;
}

// Shared fixed page header: month navigation (or a title) centered,
// settings gear to the right.
const PageHeader: React.FC<PageHeaderProps> = ({ mode, title }) => {
  const navigate = useNavigate();
  const { currentMonth, goToPreviousMonth, goToNextMonth, getMonthName, getPreviousMonthName, getNextMonthName } = useMonth();

  const currentYear = new Date().getFullYear();
  const monthLabel = currentMonth.getFullYear() === currentYear
    ? getMonthName(currentMonth)
    : `${getMonthName(currentMonth)} ${currentMonth.getFullYear()}`;

  return (
    <div className="page-header bg-white shadow-sm border-b border-gray-200">
      <div className="page-header-content px-4 py-2.5 flex items-center">
        <div className="flex-1"></div>
        {mode === 'month' ? (
          <div className="flex items-center gap-1">
            <button
              onClick={goToPreviousMonth}
              className="flex items-center gap-0.5 px-2 py-1.5 text-sm text-gray-500 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ChevronLeft size={16} />
              <span className="hidden sm:inline">{getPreviousMonthName()}</span>
            </button>
            <h1 className="text-lg font-bold text-gray-900 w-32 text-center">{monthLabel}</h1>
            <button
              onClick={goToNextMonth}
              className="flex items-center gap-0.5 px-2 py-1.5 text-sm text-gray-500 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <span className="hidden sm:inline">{getNextMonthName()}</span>
              <ChevronRight size={16} />
            </button>
          </div>
        ) : (
          <h1 className="text-lg font-bold text-gray-900">{title}</h1>
        )}
        <div className="flex-1 flex justify-end">
          <button
            onClick={() => navigate('/settings')}
            className="p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
            title="Inställningar"
          >
            <Settings size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
